import React, { Component } from "react"
import _ from 'lodash'

import { Get } from "utils/axios"
import { ErrorHandler } from "utils/requestError"

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      categories: []
    }

    onChangeDataHOC = (key, val) => this.setState({ [key]: val })

    load = (param) => this.setState({ loading: param })

    getCategories = (id) =>
      Get(
        `/category`,
        this.getCategoriesSuccess,
        ErrorHandler,
        this.load
      )
      getCategoriesSuccess = (payload) => {
      this.setState({ categories: payload.data })
    }

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoadData={this.state.loading}
          getCategories={this.getCategories}
          onChangeDataHOC={this.onChangeDataHOC}
        />
      )
    }
  }
  return WithHOC
}

export default HOC
